import { Suspense, lazy } from 'react';

import { FeatureFlagged } from '@spotify/confidence-core-react';

const LazyTourResumer = lazy(() => import('./TourResumer'));

export const TourResumer = () => (
  <FeatureFlagged with="onboarding-tours">
    <Suspense fallback={null}>
      <LazyTourResumer />
    </Suspense>
  </FeatureFlagged>
);
